export default __webpack_public_path__ + "static/media/IC00065-common.e41bc7bd.svg";